"use client"

import { useState, useEffect } from "react"

const LOC_STORAGE_USER_COUNTRY_KEY = "userCountry"

export const useUserCountry = () => {
  const [countryCode, setCountryCode] = useState("")
  const isRussian = countryCode.toUpperCase() === "RU"

  useEffect(() => {
    setCountryCode(localStorage.getItem(LOC_STORAGE_USER_COUNTRY_KEY) || "")

    async function getUserCountry() {
      const res = await fetch(`https://freeipapi.com/api/json/`, {
        headers: {
          Authorization: `Bearer ${process.env.NEXT_PUBLIC_IPAPI_KEY}`,
        },
      })

      if (!res.ok) {
        throw new Error("Failed to fetch user location data.")
      }

      const { countryCode } = await res.json()

      setCountryCode(countryCode)
      localStorage.setItem(LOC_STORAGE_USER_COUNTRY_KEY, countryCode)
    }

    getUserCountry()
  }, [])

  return { countryCode, isRussian }
}
